export const calcAgrarianismConversion = (selectedFarmsForConversion) => {
  const farmsCount = selectedFarmsForConversion.length;

  const groupsOfThree = Math.floor(farmsCount / 3);
  const remainder = farmsCount % 3;

  let coins = groupsOfThree * 2; // за каждые 3 урона теряем 2 размера

  if (remainder === 2) {
    coins += 1; // за оставшиеся 2 урона теряем 1
  }

  const isLastFarmNotUsed = remainder === 1;

  const usedSupplyCount = isLastFarmNotUsed ? selectedFarmsForConversion.length - 1 : selectedFarmsForConversion.length;

  return {coins, isLastFarmNotUsed, usedSupplyCount};
}